import React, { useState, useEffect, useContext } from "react";
import ResizableRect from "react-resizable-rotatable-draggable";
import MyContext from "../../context/MyContext";

export const MyResize = ({
  resizeRef,
  resizeRef2,
  draggerRef,
  values,
  type,
  Editable,
  index,
  setIsTTS,
  MultiDrag,
  Call_ScreenShot,
  setCall_ScreenShot,
}) => {
  const ResizeRef = resizeRef.current;
  const ResizeRef2 = resizeRef2?.current;
  const DraggerRef = draggerRef?.current;

  const {
    setLayersData,
    LayersData,
    clone,
    setRedoLayer,
    UndoLayer,
    setUndoLayer,
    ChangeCount,
    setChangeCount,
    EditorZoom,
    DraggableTextRef,
    Dragging,
    setDragging,
    IsPressedShiftKey,
    setIsPressedShiftKey,
    enableAutoGuides,
    setenableAutoGuides,
    seteditableObject,
  } = useContext(MyContext);

  const StackStore = () => {
    return new Promise((resolve) => {
      let stack = [...UndoLayer];
      let PrevArray = clone(LayersData);
      if (stack.length < 10) {
        stack.push(PrevArray);
        setUndoLayer(stack);
        setRedoLayer([]);
      } else {
        stack.shift();
        stack.push(PrevArray);
        setUndoLayer(stack);
        setRedoLayer([]);
      }

      resolve();
    });
  };

  const [resize, setresize] = useState({
    top: (values.y * EditorZoom) / 100,
    left: (values.x * EditorZoom) / 100,
    width: (values.width * EditorZoom) / 100,
    height: (values.height * EditorZoom) / 100,
  });

  const [Rotate, setRotate] = useState(values.rotateAngle);

  useEffect(() => {
    if (values) {
      if (values.type == "basicShape") {
        setresize({
          top: (values.y * EditorZoom) / 100,
          left: (values.x * EditorZoom) / 100,
          width: (values.width * EditorZoom) / 100,
          height: (values.height * EditorZoom) / 100,
        });
      } else {
        setresize({
          top: (values.y * EditorZoom) / 100,
          left: (values.x * EditorZoom) / 100,
          width: (values.width * EditorZoom) / 100,
          height: (values.height * EditorZoom) / 100,
        });
      }

      setRotate(values.rotateAngle);
    }
  }, []);

  // const onLineWrapDoSomething = ( ) =>{

  //   alert("wrap")
  // }

  const handleResize = ({ top, left, width, height }, isShiftKey, type) => {
    //this is for handling left settings panel
    //ShowPanelLeft

    seteditableObject({ showPanel: true, editableItem: values });

    //this for handling Trackers dotted border hover
    if (!Dragging) {
      setDragging(true);
    }

    if (values.type === "text") {
      const _TextDiv = document.getElementById("Text-" + values.AnimationId);
      const _InnerDiv = document.getElementById("Inner-" + values.AnimationId);
      const _showDiv = document.getElementById("showDiv-" + values.AnimationId);
      const _OuterDiv = document.getElementById("Outer-" + values.AnimationId);

      if (type === "r") {
        let finalWidth =
          parseFloat(_TextDiv.style.width.split("px")[0]) -
          _OuterDiv.children[0].clientWidth;
        const _plusWidth = Math.abs(width - _OuterDiv.children[0].clientWidth);

        if (
          parseFloat(_showDiv.style.width.split("px")[0]) <=
          _TextDiv.clientWidth
        ) {
          if (_TextDiv.clientWidth < width) {
            _TextDiv.style.width =
              _OuterDiv.children[0].clientWidth - finalWidth + "px";
            values.spanWidth = _TextDiv.style.width;
            setresize({
              ...resize,
              width: Math.round(width),
              height: _OuterDiv.children[0].clientHeight,
            });

            if (ResizeRef) {
              ResizeRef.style.height =
                _OuterDiv.children[0].clientHeight + "px";
              ResizeRef.style.width = width + "px";
            }

            if (ResizeRef2) {
              ResizeRef2.style.width = width + "px";
              ResizeRef2.style.height =
                _OuterDiv.children[0].clientHeight + "px";
            }
          } else {
            _TextDiv.style.width = width + "px";
            values.spanWidth = _TextDiv.style.width;
            setresize({
              ...resize,
              width: width,
              height: _OuterDiv.children[0].clientHeight,
            });
            if (ResizeRef) {
              ResizeRef.style.height =
                _OuterDiv.children[0].clientHeight + "px";
              ResizeRef.style.width = width + "px";
            }

            if (ResizeRef2) {
              ResizeRef2.style.width = width + "px";
              ResizeRef2.style.height =
                _OuterDiv.children[0].clientHeight + "px";
            }
          }
        } else if (
          parseFloat(_InnerDiv.style.height.split("px")[0]) <
          _OuterDiv.children[0].clientHeight
        ) {
          _TextDiv.style.width =
            _OuterDiv.children[0].clientWidth - finalWidth + "px";
          values.spanWidth = _TextDiv.style.width;
          setresize({
            ...resize,
            width: Math.round(width),
            height: _OuterDiv.children[0].clientHeight,
          });
          if (ResizeRef) {
            ResizeRef.style.height = _OuterDiv.children[0].clientHeight + "px";
            ResizeRef.style.width = width + "px";
          }

          if (ResizeRef2) {
            if (ResizeRef2) {
              ResizeRef2.style.width = width + "px";
              ResizeRef2.style.height =
                _OuterDiv.children[0].clientHeight + "px";
            }
          }
        } else {
          _TextDiv.style.width = "";
          values.spanWidth = _TextDiv.style.width;
          setresize({
            ...resize,
            width: Math.round(width),
            height: _OuterDiv.children[0].clientHeight,
          });

          if (ResizeRef) {
            ResizeRef.style.height = _OuterDiv.children[0].clientHeight + "px";
            ResizeRef.style.width = width + "px";
          }

          if (ResizeRef2) {
            if (ResizeRef2) {
              ResizeRef2.style.width = width + "px";
              ResizeRef2.style.height =
                _OuterDiv.children[0].clientHeight + "px";
            }
          }
        }
      } else if (type === "br") {
        // const _plusHeight = Math.abs(
        //   height - _OuterDiv.children[0].clientHeight
        // );
        // const _plusWidth = Math.abs(width - _TextDiv.clientWidth);

        setresize({
          width: Math.round(width),
          height: Math.round(height),
          left: parseInt(Math.round(left)),
          top: parseInt(Math.round(top)),
        });

        if (ResizeRef) {
          ResizeRef.style.width = width + "px";
          ResizeRef.style.height = height + "px";
          ResizeRef.style.left = left + "px";
          ResizeRef.style.top = top + "px";
        }

        if (ResizeRef2) {
          ResizeRef2.style.width = width + "px";
          ResizeRef2.style.height = height + "px";
          ResizeRef2.style.left = left + "px";
          ResizeRef2.style.top = top + "px";
        }

        // 0.85 is actually a ratio append from dividing fontsize by height
        // when the text was originally adding canvas first time
        //handles style changes on banner to check wrapping
        // const observer = new MutationObserver(mutations =>
        //   mutations.forEach(mutationRecord => onLineWrapDoSomething())
        // );
        // observer.observe(_TextDiv, { attributes : true, attributeFilter : ['style'] });

        var ratio = parseFloat(48) / 57;
        _TextDiv.style.fontSize = height * ratio + "px";
        values.fontSize = height * 0.85;
      } else if (type === "tr") {
        const _plusHeight = Math.abs(
          height - _OuterDiv.children[0].clientHeight
        );
        setresize({
          height: Math.round(height + _plusHeight),
          width: Math.round(width),
          left: parseInt(Math.round(left)),
          top: parseInt(Math.round(top)),
        });
        if (ResizeRef) {
          ResizeRef.style.width = width + "px";
          ResizeRef.style.height = height + _plusHeight + "px";
          ResizeRef.style.left = left + "px";
          ResizeRef.style.top = top + "px";
        }

        if (ResizeRef2) {
          ResizeRef2.style.width = width + "px";
          ResizeRef2.style.height = height + _plusHeight + "px";
          ResizeRef2.style.left = left + "px";
          ResizeRef2.style.top = top + "px";
        }

        _TextDiv.style.fontSize = height * 0.85 + "px";
        values.fontSize = height * 0.85;
      } else if (type === "tl") {
        const _plusHeight = Math.abs(
          height - _OuterDiv.children[0].clientHeight
        );
        setresize({
          height: Math.round(height + _plusHeight),
          width: Math.round(width),
          left: parseInt(Math.round(left)),
          top: parseInt(Math.round(top)),
        });
        if (ResizeRef) {
          ResizeRef.style.width = width + "px";
          ResizeRef.style.height = height + _plusHeight + "px";
          ResizeRef.style.left = left + "px";
          ResizeRef.style.top = top + "px";
        }

        if (ResizeRef2) {
          ResizeRef2.style.width = width + "px";
          ResizeRef2.style.height = height + _plusHeight + "px";
          ResizeRef2.style.left = left + "px";
          ResizeRef2.style.top = top + "px";
        }

        _TextDiv.style.fontSize = height * 0.85 + "px";
        values.fontSize = height * 0.85;
      } else if (type === "bl") {
        const _plusHeight = Math.abs(
          height - _OuterDiv.children[0].clientHeight
        );
        setresize({
          height: Math.round(height + _plusHeight),
          width: Math.round(width),
          left: parseInt(Math.round(left)),
          top: parseInt(Math.round(top)),
        });

        if (ResizeRef) {
          ResizeRef.style.width = width + "px";
          ResizeRef.style.height = height + _plusHeight + "px";
          ResizeRef.style.left = left + "px";
          ResizeRef.style.top = top + "px";
        }

        if (ResizeRef2) {
          ResizeRef2.style.width = width + "px";
          ResizeRef2.style.height = height + _plusHeight + "px";
          ResizeRef2.style.left = left + "px";
          ResizeRef2.style.top = top + "px";
        }

        _TextDiv.style.fontSize = height * 0.85 + "px";
        values.fontSize = height * 0.85;
      } else if (type === "l") {
        let finalWidth =
          parseFloat(_TextDiv.style.width.split("px")[0]) -
          _OuterDiv.children[0].clientWidth;

        if (
          parseFloat(_showDiv.style.width.split("px")[0]) <=
          _TextDiv.clientWidth
        ) {
          if (_TextDiv.clientWidth < width) {
            _TextDiv.style.width =
              _OuterDiv.children[0].clientWidth - finalWidth + "px";
            values.spanWidth = _TextDiv.style.width;
            setresize({
              ...resize,
              left: parseInt(Math.round(left)),
              width: Math.round(width),
              height: _OuterDiv.children[0].clientHeight,
            });

            if (ResizeRef) {
              ResizeRef.style.height =
                _OuterDiv.children[0].clientHeight + "px";
              ResizeRef.style.width = width + "px";
              ResizeRef.style.left = left + "px";
            }

            if (ResizeRef2) {
              ResizeRef2.style.width = width + "px";
              ResizeRef2.style.left = left + "px";
              ResizeRef2.style.height =
                _OuterDiv.children[0].clientHeight + "px";
            }
          } else {
            _TextDiv.style.width = width + "px";
            values.spanWidth = _TextDiv.style.width;
            // _TextDiv.style.height = height + "px"
            setresize({
              ...resize,
              left: parseInt(Math.round(left)),
              width: width,
              height: _OuterDiv.children[0].clientHeight,
            });

            if (ResizeRef) {
              ResizeRef.style.height =
                _OuterDiv.children[0].clientHeight + "px";
              ResizeRef.style.width = width + "px";
              ResizeRef.style.left = left + "px";
            }

            if (ResizeRef2) {
              ResizeRef2.style.width = width + "px";
              ResizeRef2.style.left = left + "px";
              ResizeRef2.style.height =
                _OuterDiv.children[0].clientHeight + "px";
            }
          }
        } else if (
          parseFloat(_InnerDiv.style.height.split("px")[0]) <
          _OuterDiv.children[0].clientHeight
        ) {
          _TextDiv.style.width =
            _OuterDiv.children[0].clientWidth - finalWidth + "px";
          values.spanWidth = _TextDiv.style.width;
          // _TextDiv.style.height = _OuterDiv.children[0].clientHeight - finalHeight + "px"
          setresize({
            ...resize,
            left: parseInt(Math.round(left)),
            width: Math.round(width),
            height: _OuterDiv.children[0].clientHeight,
          });
          if (ResizeRef) {
            ResizeRef.style.height = _OuterDiv.children[0].clientHeight + "px";
            ResizeRef.style.width = width + "px";
            ResizeRef.style.left = left + "px";
          }

          if (ResizeRef2) {
            ResizeRef2.style.width = width + "px";
            ResizeRef2.style.left = left + "px";
            ResizeRef2.style.height = _OuterDiv.children[0].clientHeight + "px";
          }
        } else {
          _TextDiv.style.width = "";
          values.spanWidth = _TextDiv.style.width;
          setresize({
            ...resize,
            left: parseInt(Math.round(left)),
            width: Math.round(width),
            height: _OuterDiv.children[0].clientHeight,
          });
          if (ResizeRef) {
            ResizeRef.style.height = _OuterDiv.children[0].clientHeight + "px";
            ResizeRef.style.width = width + "px";
            ResizeRef.style.left = left + "px";
          }

          if (ResizeRef2) {
            ResizeRef2.style.width = width + "px";
            ResizeRef2.style.left = left + "px";
            ResizeRef2.style.height = _OuterDiv.children[0].clientHeight + "px";
          }
        }
      }
    } else if (values.type === "AnimatedText") {
      setresize({
        width: Math.round(width),
        height: Math.round(height),
        left: parseInt(Math.round(left)),
        top: parseInt(Math.round(top)),
      });

      ResizeRef.style.width = width + "px";
      ResizeRef.style.height = height + "px";
      ResizeRef.style.left = left + "px";
      ResizeRef.style.top = top + "px";

      if (ResizeRef2) {
        ResizeRef2.style.width = width + "px";
        ResizeRef2.style.height = height + "px";
        ResizeRef2.style.left = left + "px";
        ResizeRef2.style.top = top + "px";
      }

      const array = Array.from(LayersData);

      for (let i = 0; i < array.length; i++) {
        if (array[i] === values) {
          array[i].fontSize = (array[i].fontSize + width) / 5;
          break;
        }
      }

      setLayersData(array);
    } else if (values.type.toLowerCase() === "character") {
      const _ResizeDiv = document.getElementById("Outer-" + values.AnimationId);
      const _ResizeDiv2 = document.getElementById(
        "showDiv-" + values.AnimationId
      );
      setresize({
        width: Math.round(width),
        height: Math.round(height),
        left: parseInt(Math.round(left)),
        top: parseInt(Math.round(top)),
      });
      if (_ResizeDiv) {
        _ResizeDiv.style.width = width + "px";
        _ResizeDiv.style.height = height + "px";
        // _ResizeDiv.style.transform = `translate(${left}px, ${top}px)`
        _ResizeDiv.style.left = left + "px";
        _ResizeDiv.style.top = top + "px";
      }

      if (_ResizeDiv2) {
        _ResizeDiv2.style.width = width + "px";
        _ResizeDiv2.style.height = height + "px";
        _ResizeDiv2.style.left = left + "px";
        _ResizeDiv2.style.top = top + "px";
      }
    } else if (values.type === "Shape" || values.type === "basicShape") {
      const _ResizeDiv = document.getElementById("Outer-" + values.AnimationId);
      const _ResizeDiv2 = document.getElementById(
        "showDiv-" + values.AnimationId
      );

      setresize({
        width: Math.round(width),
        height: Math.round(height),
        left: parseInt(Math.round(left)),
        top: parseInt(Math.round(top)),
      });

      // console.log("resize",resize);
      // console.log("width",width);
      // console.log("height",height);

      if (_ResizeDiv) {
        _ResizeDiv.style.width = width + "px";
        _ResizeDiv.style.height = height + "px";
        // _ResizeDiv.style.transform = `translate(${left}px, ${top}px)`
        _ResizeDiv.style.left = left + "px";
        _ResizeDiv.style.top = top + "px";
      }

      if (_ResizeDiv2) {
        _ResizeDiv2.style.width = width + "px";
        _ResizeDiv2.style.height = height + "px";
        _ResizeDiv2.style.left = left + "px";
        _ResizeDiv2.style.top = top + "px";
      }
    } else {
      setresize({
        width: Math.round(width),
        height: Math.round(height),
        left: parseInt(Math.round(left)),
        top: parseInt(Math.round(top)),
      });
      ResizeRef.style.width = width + "px";
      ResizeRef.style.height = height + "px";
      // ResizeRef.style.transform = `translate(${left}px, ${top}px)`
      ResizeRef.style.left = left + "px";
      ResizeRef.style.top = top + "px";

      if (ResizeRef2) {
        ResizeRef2.style.width = width + "px";
        ResizeRef2.style.height = height + "px";
        ResizeRef2.style.left = left + "px";
        ResizeRef2.style.top = top + "px";
      }
    }
  };

  useEffect(() => {
    const array = Array.from(LayersData);
    let change = false;

    array.map((value) => {
      if (value.key === values.key) {
        if (value.type === "AnimatedText") {
          if (!value.AddedInSVG) {
            value.width = value.width / 1.1;
            value.height = value.height / 1.1;
            setresize({
              width: Math.round(value.width),
              height: Math.round(value.height),
              left: parseInt(Math.round(value.x)),
              top: parseInt(Math.round(value.y)),
            });

            if (ResizeRef) {
              const _svg = document.getElementById(
                "Outer-" + value.AnimationId
              );
              if (_svg) {
                _svg.style.width = value.width + "px";
                _svg.style.height = value.height + "px";
                _svg.style.left = value.x + "px";
                _svg.style.top = value.y + "px";
                value.AddedInSVG = true;
                value.LoadLottie = true;
                change = true;
              }
            }

            // if (height > _svg.firstChild.offsetHeight) {

            if (value.showDiv) {
              if (ResizeRef2) {
                const _svg2 = document.getElementById(
                  `Outer-` + value.AnimationId
                );
                if (_svg2) {
                  _svg2.style.width = 288.575 + "px";
                  _svg2.style.height = 238 + "px";
                  _svg2.style.left = value.x + "px";
                  _svg2.style.top = value.y + "px";
                  value.AddedInSVG = true;
                  value.LoadLottie = true;
                  change = true;
                }
              }
            }
          }
        } else if (value.type === "text") {
          //debugger;
          if (value.isFontButtonClick) {
            const _OuterDiv = document.getElementById(
              "Outer-" + value.AnimationId
            );

            if (!_OuterDiv) return;

            setresize({
              height: _OuterDiv.children[0].clientHeight,
              width: _OuterDiv.children[0].clientWidth,
              top: (values.y * EditorZoom) / 100,
              left: (values.x * EditorZoom) / 100,
            });
            value.isFontButtonClick = false;
            value.width = _OuterDiv.children[0].clientWidth;
            value.height = _OuterDiv.children[0].clientHeight;
            change = true;
            // This is commented to fix weird character position changing on text double click
            // if (ResizeRef) {
            //   ResizeRef.style.height =
            //     _OuterDiv.children[0].clientHeight + "px";
            //   ResizeRef.style.width = _OuterDiv.children[0].clientWidth + "px";
            //   ResizeRef.style.left = value.x + "px";
            // }

            if (ResizeRef2) {
              ResizeRef2.style.width = _OuterDiv.children[0].clientWidth + "px";
              ResizeRef2.style.left = value.x + "px";
              ResizeRef2.style.height =
                _OuterDiv.children[0].clientHeight + "px";
            }
          }
        }
      }
    });

    if (change) {
      setLayersData(array);
    }
  }, [LayersData, ResizeRef]);

  const handleUp = async () => {
    //this for handling Trackers dotted border hover
    setDragging(false);

    await StackStore();
    const array = Array.from(LayersData);
    const _ResizeDiv = document.getElementById("Outer-" + values.AnimationId);

    for (var i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        if (values.type === "basicShape") {
          //this "_ResizeDiv.style.width.split("px")[0]" used to be "resize.width" but it was not working for Shift key as state was not getting updated.

          array[i].width =
            (_ResizeDiv.style.width.split("px")[0] / EditorZoom) * 100;
          array[i].height =
            (_ResizeDiv.style.height.split("px")[0] / EditorZoom) * 100;
        } else {
          array[i].width =
            (_ResizeDiv.style.width.split("px")[0] / EditorZoom) * 100;
          array[i].height =
            (_ResizeDiv.style.height.split("px")[0] / EditorZoom) * 100;
        }

        array[i].x = (_ResizeDiv.style.left.split("px")[0] / EditorZoom) * 100;
        array[i].y = (_ResizeDiv.style.top.split("px")[0] / EditorZoom) * 100;
        array[i].originalX =
          (_ResizeDiv.style.left.split("px")[0] / EditorZoom) * 100;
        array[i].originalWidth =
          (_ResizeDiv.style.width.split("px")[0] / EditorZoom) * 100;
        array[i].originalHeight =
          (_ResizeDiv.style.height.split("px")[0] / EditorZoom) * 100;
        array[i].originalY =
          (_ResizeDiv.style.top.split("px")[0] / EditorZoom) * 100;
      }
    }

    setLayersData(array);
    setChangeCount(ChangeCount + 1);
  };

  // const handleUp2 = async () => {
  //     await StackStore();
  //     let height = ResizeRef.firstChild.nextSibling.offsetHeight
  //     const array = Array.from(LayersData);
  //     for (var i = 0; i < array.length; i++) {
  //         if (array[i].key === values.key) {
  //             array[i].width = (resize.width / EditorZoom) * 100;
  //             array[i].originalX = (resize.left / EditorZoom) * 100;
  //             array[i].x = (resize.left / EditorZoom) * 100;
  //             array[i].height = (height / EditorZoom) * 100;
  //             array[i].originalWidth = (resize.width / EditorZoom) * 100;
  //             array[i].originalHeight = (resize.height / EditorZoom) * 100;
  //             array[i].originalY = (resize.top / EditorZoom) * 100;
  //         }
  //     }
  //     setLayersData(array);
  //     setChangeCount(ChangeCount + 1)
  // }

  const [Arrow, setArrow] = useState("nw, ne, se, sw");

  useEffect(() => {
    if (
      type === "Character" ||
      type === "Video" ||
      type === "Props" ||
      type === "basicShape" ||
      type === "Shape" ||
      type === "AnimatedText"
    ) {
      setArrow("nw, ne, se, sw");
    } else if (type === "text") {
      // setArrow('w, e')
      setArrow("w, e");
      // setArrow('nw, ne, se, sw')
    } else {
      setArrow("n, w, s, e, nw, ne, se, sw");
    }
  }, [type]);

  useEffect(() => {
    if (values.type === "basicShape") {
      if (!IsPressedShiftKey) {
        setArrow("n, w, s, e, nw, ne, se, sw");
      } else {
        setArrow("nw, ne, se, sw");
      }
    }
  }, [IsPressedShiftKey]);

  const Rotater = (rotateAngle) => {
    setRotate(rotateAngle);
    if (ResizeRef) ResizeRef.style.transform = `rotate(${rotateAngle}deg)`;

    if (ResizeRef2) ResizeRef2.style.transform = `rotate(${rotateAngle}deg)`;
  };

  const RotaterEnd = async () => {
    await StackStore();
    const array = Array.from(LayersData);
    for (var i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].rotateAngle = Rotate;
        array[i].originalRotateAngle = Rotate;
        array[i].Editable = true;
        array[i].toolbar = true;
      } else {
        array[i].Editable = false;
        array[i].toolbar = false;
      }
    }
    setLayersData(array);
    setChangeCount(ChangeCount + 1);
  };

  const [snappingCount, setsnappingCount] = useState(0);

  // this is call when characters or other things are selected and then drag
  const Drag = (deltaX, deltaY) => {
    console.log("dragging");
    setresize({
      width: Math.round(resize.width),
      height: Math.round(resize.height),
      left: Math.round(resize.left + deltaX),
      top: Math.round(resize.top + deltaY),
    });

    try {
      const _OuterDiv = document.getElementById("Outer-" + values.AnimationId);
      const _showDiv = document.getElementById("showDiv-" + values.AnimationId);
      document.getElementById("Outer-" + values.AnimationId).style.border =
        "2px solid black";
      if (_OuterDiv) {
        _OuterDiv.style.left = resize.left + deltaX + "px";
        _OuterDiv.style.top = resize.top + deltaY + "px";
      }

      if (_showDiv) {
        _showDiv.style.left = resize.left + deltaX + "px";
        _showDiv.style.top = resize.top + deltaY + "px";
      }
    } catch {
      // debugger;
    }
    var isMatching = false;
    let change = false;
    const newArray = Array.from(LayersData);
    for (var i = 0; i < newArray.length; i++) {
      if (newArray[i].key === values.key) {
        if (newArray[i].showDiv === true) {
          newArray[i].showDiv = false;
          change = true;
        }

        if (!newArray[i].DrapEndAnimatedText) {
          newArray[i].DrapEndAnimatedText = true;
          change = true;
        }
        // if (newArray[i].Editable === true) {
        //     newArray[i].Editable = false;
        //     change = true
        // }
      }
      //showing guides
      else {
        if (enableAutoGuides) {
          //when left side matches left side of object

          if (
            resize.left <= newArray[i].x + 1 &&
            resize.left >= newArray[i].x - 1
          ) {
            isMatching = true;
            document.getElementById("guideY_left").style.display = "block";
            document.getElementById("guideY_left").style.left =
              newArray[i].x + "px";
          }
          //when left side matches right side of object
          if (
            resize.left <= newArray[i].x + newArray[i].width + 1 &&
            resize.left >= newArray[i].x + newArray[i].width - 1
          ) {
            isMatching = true;
            document.getElementById("guideY_left").style.display = "block";
            document.getElementById("guideY_left").style.left =
              newArray[i].x + newArray[i].width + "px";
          }
          //when right side matches left side of object
          if (
            resize.width + resize.left <= newArray[i].x + 1 &&
            resize.width + resize.left >= newArray[i].x - 1
          ) {
            isMatching = true;
            document.getElementById("guideY_right").style.display = "block";
            document.getElementById("guideY_right").style.left =
              newArray[i].x + "px";
          }
          //when right side matches right side of object
          if (
            resize.width + resize.left <=
              newArray[i].x + newArray[i].width + 1 &&
            resize.width + resize.left >= newArray[i].x + newArray[i].width - 1
          ) {
            isMatching = true;
            document.getElementById("guideY_right").style.display = "block";
            document.getElementById("guideY_right").style.left =
              newArray[i].x + newArray[i].width + "px";
          }
          //when top side matches top side of object
          if (
            resize.top <= newArray[i].y + 1 &&
            resize.top >= newArray[i].y - 1
          ) {
            isMatching = true;
            document.getElementById("guideX_top").style.display = "block";
            document.getElementById("guideX_top").style.top =
              newArray[i].y + "px";
          }
          //when top side matches bottom side of object
          if (
            resize.top <= newArray[i].y + newArray[i].height + 1 &&
            resize.top >= newArray[i].y + newArray[i].height - 1
          ) {
            isMatching = true;
            document.getElementById("guideX_top").style.display = "block";
            document.getElementById("guideX_top").style.top =
              newArray[i].y + newArray[i].height + "px";
          }
          //when bottom side matches top side of object
          if (
            resize.top + resize.height <= newArray[i].y + 1 &&
            resize.top + resize.height >= newArray[i].y - 1
          ) {
            isMatching = true;
            document.getElementById("guideX_top").style.display = "block";
            document.getElementById("guideX_top").style.top =
              newArray[i].y + "px";
          }
          //when bottom side matches bottom side of object
          if (
            resize.top + resize.height <=
              newArray[i].y + newArray[i].height + 1 &&
            resize.top + resize.height >= newArray[i].y + newArray[i].height - 1
          ) {
            isMatching = true;
            document.getElementById("guideX_top").style.display = "block";
            document.getElementById("guideX_top").style.top =
              newArray[i].y + newArray[i].height + "px";
          }
          //hide guide when nothing matches
          if (!isMatching) {
            document.getElementById("guideY_right").style.display = "none";
            document.getElementById("guideY_left").style.display = "none";
            document.getElementById("guideX_top").style.display = "none";
            document.getElementById("guideX_bottom").style.display = "none";
          }
        }

        // //snap to grid
        // if (
        //   resize.left <= newArray[i].x + 1 &&
        //   resize.left >= newArray[i].x - 1 &&
        //   snappingCount <= 1
        // ) {
        //   setsnappingCount(snappingCount + 1);
        //   setresize({
        //     width: Math.round(resize.width),
        //     height: Math.round(resize.height),
        //     left: newArray[i].x,
        //     top: Math.round(resize.top + deltaY),
        //   });

        // } else {
        //   setsnappingCount(0);
        // }
      }
    }

    if (change) {
      setLayersData(newArray);
    }
  };

  const DragEnd = async () => {
    //hidding guides
    document.getElementById("guideY_right").style.display = "none";
    document.getElementById("guideY_left").style.display = "none";
    document.getElementById("guideX_top").style.display = "none";
    document.getElementById("guideX_bottom").style.display = "none";

    document.getElementById("Outer-" + values.AnimationId).style.border =
      "none";

    //this for handling Trackers dotted border hover
    setDragging(false);

    await StackStore();
    const array = Array.from(LayersData);
    for (var i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].originalX = (resize.left / EditorZoom) * 100;
        array[i].originalY = (resize.top / EditorZoom) * 100;
        array[i].x = (resize.left / EditorZoom) * 100;
        array[i].y = (resize.top / EditorZoom) * 100;
        array[i].FurtherSetting = false;
        array[i].Editable = true;
        array[i].toolbar = true;
        array[i].showDiv = true;
        // array[i].isTextBox = false;

        if (array[i].type == "AnimatedText") {
          if (array[i].JSONValue?.fromAssets) {
            array[i].JSONValue.assets.map((value) => {
              if (value.layers[0]?.nm.toLowerCase().includes("text"))
                if (value.layers[0].t?.d?.k[0]?.s)
                  value.layers[0].t.d.k[0].s.isTextBox = false;
            });
          } else {
            array[i].JSONValue?.layers.map((x) => {
              if (x.nm.toLowerCase().includes("text"))
                x.t.d.k[0].s.isTextBox = false;
            });
          }

          array[i].DrapEndAnimatedText = true;
        }
      } else {
        array[i].Editable = false;
        array[i].toolbar = false;
        array[i].showDiv = false;
      }
    }

    if (!Call_ScreenShot) {
      if (ChangeCount > 2) {
        setCall_ScreenShot(true);
        setChangeCount(0);
      }
    }
    setLayersData(array);
    setChangeCount(ChangeCount + 1);
  };

  const SimpleDrag = (deltaX, deltaY) => {
    setresize({
      width: Math.round(resize.width),
      height: Math.round(resize.height),
      left: Math.round(resize.left + deltaX),
      top: Math.round(resize.top + deltaY),
    });
    ResizeRef.style.left = resize.left + deltaX + "px";
    ResizeRef.style.top = resize.top + deltaY + "px";
    // ResizeRef2.style.left = (resize.left + deltaX) + "px"
    // ResizeRef2.style.top = (resize.top + deltaY) + "px"
  };

  const SimpleDragEnd = async () => {
    await StackStore();
    const array = Array.from(LayersData);
    for (var i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].originalX = (resize.left / EditorZoom) * 100;
        array[i].originalY = (resize.top / EditorZoom) * 100;
        array[i].x = (resize.left / EditorZoom) * 100;
        array[i].y = (resize.top / EditorZoom) * 100;
        array[i].Editable = true;
        array[i].toolbar = true;
      } else {
        array[i].Editable = false;
        array[i].toolbar = false;
      }
    }
    setLayersData(array);
    setChangeCount(ChangeCount + 1);
  };

  const Start = (params) => {
    //this for handling Trackers dotted border hover
    setDragging(true);
    setIsTTS(false);
    const array = Array.from(LayersData);
    for (var i = 0; i < array.length; i++) {
      array[i].toolbar = false;
      array[i].FurtherSetting = false;
      array[i].Editable = false;
      array[i].showDiv = false;
      if (array[i].key == values.key) {
        array[i].Editable = true;
        array[i].showDiv = true;
      }
    }
    setLayersData(array);
  };

  useEffect(() => {
    setTimeout(() => {
      var element = document.getElementsByClassName("single-resizer");

      for (let SubElement of element) {
        if (element[0].firstChild) {
          // if(values.type === "Character")
          // {
          //     if (SubElement.classList.contains('StyledRect-sc-1uso172-0')) {
          //          SubElement.classList.remove("StyledRect-sc-1uso172-0");
          //     }

          //     if (SubElement.classList.contains('jzmUzU')) {
          //         SubElement.classList.remove("jzmUzU");
          //     }

          //     if (SubElement.classList.contains('rect')) {
          //         SubElement.classList.remove("rect");
          //     }

          //     if (SubElement.classList.contains('single-resizer')) {
          //         SubElement.classList.remove("single-resizer");
          //     }
          // }

          if (values.type == "text") {
            //Commented this to fix Resize size on Zoom
            // SubElement.style.width = values.width + "px";
            // SubElement.style.height = values.height + "px";

            SubElement.ondblclick = function () {
              dblcheck();
            };
          }
        }
      }

      // if (values.type == 'text') {

      //     var element = document.getElementsByClassName('single-resizer')[0]

      //     if (element != undefined) {

      // if (!element.classList.contains('RectBorder')) {
      //     element.classList.add("RectBorder");
      // }

      //     element.addEventListener('dblclick', function () {

      //         dblcheck();
      //     })

      // }

      // }
    }, 100);
  }, [Arrow, values.height]);

  const dblcheck = () => {
    const array = Array.from(LayersData);
    for (var i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        if (array[i].originalText) {
          array[i].text = array[i].originalText;
        }
        if (array[i].originalFontSize) {
          array[i].fontSize = array[i].originalFontSize;
        }
        array[i].edit = "true";
        array[i].FurtherSetting = true;
        array[i].toolbar = false;
        array[i].Editable = false;
      }
    }
    setLayersData(array);
  };

  // const TextClick = () => {
  //     const array = Array.from(LayersData);

  //     for (var i = 0; i < array.length; i++) {
  //         if (array[i].key === value.key) {
  //             array[i].toolbar = true;
  //             array[i].Editable = true
  //             // if (array[i].height != TextRef.current.firstChild.nextSibling.offsetHeight) {
  //             //     array[i].height = TextRef.current.firstChild.nextSibling.offsetHeight
  //             // }

  //             if (!array[i].Editable) {
  //                 if (array[i].height != TextRef.current.firstChild.offsetHeight) {
  //                     array[i].height = TextRef.current.firstChild.offsetHeight
  //                 }
  //             } else {
  //                 if (array[i].height != resizeRef.current.firstChild.offsetHeight) {
  //                     array[i].height = resizeRef.current.firstChild.offsetHeight
  //                 }
  //             }

  //         } else {
  //             array[i].toolbar = false;
  //             array[i].Editable = false
  //         }
  //     }
  //     setLayersData(array);
  // }

  return (
    <>
      {Editable && (
        <>
          {Arrow === "w, e" && (
            <ResizableRect
              rotatable={true}
              top={resize.top}
              left={resize.left}
              width={resize.width}
              height={resize.height}
              zoomable={Arrow}
              onResizeStart={Start}
              onResizeEnd={handleUp}
              onResize={handleResize}
              rotateAngle={Rotate}
              onRotate={Rotater}
              onRotateEnd={RotaterEnd}
              onDrag={Drag}
              onDragEnd={DragEnd}
              onDragStart={Start}
            />
          )}

          {Arrow === "w, e" && (
            <ResizableRect
              rotatable={true}
              left={resize.left}
              top={resize.top}
              width={resize.width}
              height={resize.height}
              aspectRatio={values.width / values.height} //size of orignal animation
              zoomable={Arrow}
              onResizeStart={Start}
              onResizeEnd={handleUp}
              onResize={handleResize}
              rotateAngle={Rotate}
              onRotate={Rotater}
              onRotateEnd={RotaterEnd}
              onDrag={Drag}
              onDragEnd={DragEnd}
              onDragStart={Start}
            />
          )}

          {Arrow === "nw, ne, se, sw" && (
            <ResizableRect
              rotatable={true}
              left={resize.left}
              top={resize.top}
              width={resize.width}
              height={resize.height}
              aspectRatio={values.width / values.height} //size of orignal animation
              zoomable={Arrow}
              onResizeStart={Start}
              onResizeEnd={handleUp}
              onResize={handleResize}
              rotateAngle={Rotate}
              onRotate={Rotater}
              onRotateEnd={RotaterEnd}
              onDrag={Drag}
              onDragEnd={DragEnd}
              onDragStart={Start}
            />
          )}

          {Arrow === "n, w, s, e, nw, ne, se, sw" && (
            <ResizableRect
              rotatable={true}
              left={resize.left}
              top={resize.top}
              width={resize.width}
              height={resize.height}
              zoomable={Arrow}
              rotateAngle={Rotate}
              onRotate={Rotater}
              onDrag={Drag}
              onDragEnd={DragEnd}
              onRotateEnd={RotaterEnd}
              onResizeStart={Start}
              onResizeEnd={handleUp}
              onResize={handleResize}
              onDragStart={Start}
              // style={{
              //   transform: values.flip + `rotate(${values.rotateAngle}deg)`,
              // }}
            />
          )}
        </>
      )}
      {!Editable && (
        <>
          <ResizableRect
            left={resize.left}
            top={resize.top}
            width={resize.width}
            height={resize.height}
            rotateAngle={Rotate}
            onDrag={SimpleDrag}
            onDragEnd={SimpleDragEnd}
            onDragStart={Start}
          />
        </>
      )}
    </>
  );
};
export default MyResize;
